import React from 'react';
import GetIntegrationAction from './action/GetIntegrationAction';
import GetIntegrationStore from './store/GetIntegrationStore';
import EditIntegrationAction from './action/EditIntegrationAction';
import EditIntegrationStore from './store/EditIntegrationStore';
import { Button, message, Spin, Switch, Icon, Menu, Dropdown, Input, Tooltip, Modal, Upload, Radio, Tabs } from 'antd';
import { LocaleProvider } from 'antd';
import Aux from "../../utils/_aux";
import { getSourceLogo } from "../../utils/getSourceImage";
import './style.scss';
import enUS from 'antd/lib/locale-provider/en_US';
import _ from 'lodash'
import { urlName } from '../../config';
import { EMAIL_SUBJECTLINE_KEY, domainCSSControl } from './Children/subjectLineConfig'
import { ChromePicker } from 'react-color'
import PreviewComponent from '../../components/PreviewComponent';
import Select from 'react-select';
import savedCSSValues from './Children/savedCSSValues';
import UploadProfileLogoAction from "../ImageUpload/action/UploadProfileLogoAction";
import UploadProfileLogoStore from '../ImageUpload/store/UploadProfileLogoStore';
import { ImageUpload } from './Children/imageUpload';
import { mappingTabName, settingLabelMap } from '../UserDetailPage/childrens/landingPageTabs';
import { availableLanguages } from '../../utils/languageConstants';
import { MetaData } from './Children/metaData';
import CustomScrollbar from '../../components/CustomScrollbar';
import GetCustomiNavigationAction from './action/GetCustomiNavigationAction';
import { applyWhiteLabelHeadTags } from '../../utils/applyWhiteLabelHeadTags';
import { CustomNavigationbarWrapper } from './Children/CustomNavigationWrapper';
import GetCustomNavigationStore from './store/GetCustomNavigationStore';
import { setInitialState } from './helpers/initialState';
import { onSendSidebarData, onUpdateSidebarData } from './helpers/customSidebarUpdate';
import CreateCustomNavigationStore from './store/CreateCutomNavigationStore';
import UpdateCustomNavigationStore from './store/UpdateCustomNavigatonStore';
import DeleteCustomNavigationAction from './action/DeleteCustomNavigationAction';
import DeleteCustomNavigationStore from './store/DeleteCustomNavigationStore';
import Header from '../AuthorizePage/children/Header';
import { decryptData, encryptData } from '../../utils/scriptEncryption';
import { appendAnalyticsScript } from '../../utils/appendingAnalyticsScript';
var languageFile = require("../../../public/languages/Translation");
var cookie = require('../../utils/cookie');
const { TextArea } = Input;
const { TabPane } = Tabs;
const RemoveNavigationMessages = {
	title: languageFile[localStorage.getItem('language')]['2053'],
	content: 'Delete Tab?',
	okText: 'Yes',
	cancelText: languageFile[localStorage.getItem('language')]["22821"],
};
const confirm = Modal.confirm;
export const integrationImages = {
	reviewshakegmb: "/images/google_index-logo.png",
	reviewshakefacebook: "/images/reviewshakefacebook-logo.png",
	reviewshakebooking: "/images/booking_index-logo.png",
	reviewshaketrustpilot: "/images/trustpilot-index-logo.png",
	tripadvisor: "/images/default3.jpg",
	yelp: "/images/default1.png",
	zomato: "/images/zomato-logo.png",
	lawyers: "/images/lawyers-logo.png",
	avvo: "/images/avvo-logo.png",
	vitals: "/images/vitals-logo.png",
	ratemds: "/images/ratemds-logo.png",
	healthgrades: "/images/Healthgrades-logo.png",
	zocdoc: "/images/zocdoc-logo.png",
	cars: "/images/cars-logo.png",
	houzz: "/images/houzz-logo.png",
	homeadvisor: "/images/homeadvisor-logo.png",
	homestars: "/images/homestars-logo.png",
	apartments: "/images/apartment-logo.png",
	rent: "/images/rent-logo.png",
	zillow: "/images/zillow-logo.png",
	cellarpass: "/images/cellarpass.png",
	productreview: "/images/productreview-logo.png",
	angieslist: "/images/angies-logo.png",
	highya: "/images/highya-logo.png",
	glassdoor: "/images/glassdoor-logo.png",
	hostelworld: "/images/hostelworld-logo.png",
	expedia: "/images/expedia-card.png",
	opentable: "/images/opentable.png",
	indeed: "/images/indeed.png",
	hotels: "/images/hotels.png",
	foursquare: "/images/fourSquare-logo.png",
	appstore: "/images/app_store_index-logo.png",
	cargurus: "/images/cargurus-logo.png",
	dealerrater: "/images/dealerrater-logo.png",
	edmunds: "/images/edmunds-logo.png",
	reserveout: "/images/reserveout-logo.png",
	talabat: "/images/talabat-logo.png",
	trustradius: "/images/trustradius-logo.png",
	capterra: "/images/capterra-logo.png",
	gtwo: "/images/gtwo-logo.png",
	airbnb: "/images/airbnb-logo.png",
	betterbusinessbureau: "/images/bbbLogo.png",
	googleplaystore: "/images/google_play-logo.png",
	ubereats: '/images/ubereats-logo.png',
	doordash: '/images/doordash-logo.png',
	grubhub: '/images/grubhub-logo.png',
	trustedshops: '/images/trustedshops-logo.png',
	cardealer: '/images/Car-Dealer-Reviews-Logo.png'

}
const htmlcss = `  <div style="position: absolute; top: 0; left: 0; padding: 30px; width: 100%; height: 100%; z-index: 3; background-image: url(https://images.unsplash.com/photo-1511914678378-2906b1f69dcf?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1280&h=1280&fit=crop)"">             
 <div style="display: flex; flex-direction: row; align-items: center; justify-content: flex-start; flex-wrap: nowrap;  text-align: center; max-width: 240px;"> 
 <img src="https://lc-whitelabel-images-prod-dev.s3-us-west-2.amazonaws.com/images/localhost%3A3000/domainLogo" /> 											 
</div> 
</div>`
export const authIntegrationImages = {
	google: "/images/google.png",
	applebusinessconnect: "/images/apple_business-logo.png",
	bing: "/images/bing-logo.png",
	facebook: "/images/facebook.png",
	booking: "/images/bookingcom.png",
	trustpilot: "/images/trustpilot-logo.png",
	playstore: "/images/google_play-logo.png",
	appleappstore: "/images/app_store-logo.png",
	// applemaps: "/images/applemaps-logo.png"
}
const happiessRateMap = {
	'1': "Promoter/Happy",
	'0': "Neutral",
	'-1': "Detractor/Unhappy",
}
const ratingList = ["fiveStar", "fourStar", "threeStar", "twoStar", "oneStar"]
const labelMap = {
	"oneStar": "1 Star",
	"twoStar": "2 Star",
	"threeStar": "3 Star",
	"fourStar": "4 Star",
	"fiveStar": "5 Star",
}
const options = [
	{ label: 'Default', value: 'Default' },
	{ label: 'Right Side Sign-up', value: 'Right' },
	{ label: 'Left Side Sign-up', value: 'Left' },
];
const cssCustomOptions = [{ label: "Default Theme", value: "Defalt_Theme" },
{ label: "Blue-white Theme", value: "Blue_Theme" },
{ label: "Customize", value: "Custom" }]
class IntegrationControl extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			loading: true,
			integrations: [],
			isSignUpRequire: false,
			showBulkLocationEdit: false,
			emailSubjectLine: {},
			showEmailEditWindow: false,
			subjectLineConfig: _.cloneDeep(EMAIL_SUBJECTLINE_KEY),
			displayColorPicker: false,
			starIconColor: '#f58258',
			domainCssControlConfig: _.cloneDeep(domainCSSControl),
			domainCssColor: {},
			showCSSPreview: false,
			selectedCSSType: {},
			fileList: [],
			selectedUploadType: { label: "Login Background", value: "loginBackground" },
			whiteLabelImages: {},
			tabVisibility: {},
			domainLanguages: [],
			analyticsScriptActivate: false,
			analyticsScriptPlacement: 'head',
			analyticsScriptText: '',
			scriptLoader: false,
			pageTitle: '',
			pageDescription: '',
			supportEmail: '',
			addressLine: '',
			city: '',
			stateName: '',
			analyticsScriptType: 'internal',
			country: '',
			zipCode: '',
			metaLoader: false,
			newUserNotificationEmails: '',
			newProfileNotificationEmails: '',
			statements: [{ rating: 1, statement: "" },
			{ rating: 2, statement: "" },
			{ rating: 3, statement: "" },
			{ rating: 4, statement: "" },
			{ rating: 5, statement: "" },],
			hasAiResponse: false,
			hasSentimentAnalysis: false,
			hasLanguageDetection: false,
			responseTemplate: false,
			integrations: 'settings',
			navigationGroup: [],
			signUpPosition: 'Default',
			marketingMessage: `<h2 style="color : red; font-size : x-large;">Marketing Message</h2>`,
			htmlStyle: `<div style="position: absolute; top: 0; left: 0; padding: 30px; width: 100%; height: 100%; z-index: 3; background-image: url(https://images.unsplash.com/photo-1511914678378-2906b1f69dcf?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1280&h=1280&fit=crop)"">             
			<div style="display: flex; flex-direction: row; align-items: center; justify-content: flex-start; flex-wrap: nowrap;  text-align: center; max-width: 240px;"> 
			<img src="https://lc-whitelabel-images-prod-dev.s3-us-west-2.amazonaws.com/images/localhost%3A3000/domainLogo?time=1607965061825" /> 											 
		   </div> 
		   </div>`
		}
		this.onGetIntegrations = this.onGetIntegrations.bind(this);
		this.listIntegrations = this.listIntegrations.bind(this);
		this.changeControl = this.changeControl.bind(this);
		this.updateControl = this.updateControl.bind(this);
		this.changeSignupStatus = this.changeSignupStatus.bind(this);
		this.onPageTitleChange = this.onPageTitleChange.bind(this);
		this.onPageDescriptionChange = this.onPageDescriptionChange.bind(this);
		this.onSupportEmailChange = this.onSupportEmailChange.bind(this);
		this.onProfileNotificationEmailChange = this.onProfileNotificationEmailChange.bind(this);
		this.onUserNotificationEmailChange = this.onUserNotificationEmailChange.bind(this);
		this.onAddressLineChange = this.onAddressLineChange.bind(this);
		this.onCityChange = this.onCityChange.bind(this);
		this.onStateNameChange = this.onStateNameChange.bind(this);
		this.onCountryChange = this.onCountryChange.bind(this);
		this.onZipCodeChange = this.onZipCodeChange.bind(this);
	}
	componentWillMount() {
		GetIntegrationStore.bind(this.onGetIntegrations);
		EditIntegrationStore.bind(this.onEditIntegrations);
		UploadProfileLogoStore.bind(this.domainLogoUploadResponse);
		GetIntegrationAction.getintegration(urlName);
		// GetCustomiNavigationAction.getCustomNavigation(urlName);
		GetCustomNavigationStore.bind(this.getCustomNavResposen);
		CreateCustomNavigationStore.bind(this.createCustomNavResponse);
		UpdateCustomNavigationStore.bind(this.updatecustomNavResponse);
		DeleteCustomNavigationStore.bind(this.deleteCustomNavResponse);

	}
	componentWillUnmount() {
		GetIntegrationStore.unbind(this.onGetIntegrations);
		EditIntegrationStore.unbind(this.onEditIntegrations);
		UploadProfileLogoStore.unbind(this.domainLogoUploadResponse);
		GetCustomNavigationStore.unbind(this.getCustomNavResposen);
		CreateCustomNavigationStore.unbind(this.createCustomNavResponse);
		UpdateCustomNavigationStore.unbind(this.updatecustomNavResponse);
		DeleteCustomNavigationStore.unbind(this.deleteCustomNavResponse);


	}
	componentDidMount() {
		let search = this.props.history.location.search;
		if (search == '') {
			this.setState({ activeKey: 'settings' });
			this.props.history.push('/authorize/admin/domain-control?settings')
		} else if (search == '?settings') {
			this.setState({ activeKey: 'settings' });
		}
		else if (search == '?integrations') {
			this.setState({ activeKey: 'integrations' });
		} else if (search == '?languages') {
			this.setState({ activeKey: 'languages' });
		} else if (search == '?visibility') {
			this.setState({ activeKey: 'visibility' });
		} else if (search == '?ai') {
			this.setState({ activeKey: 'ai' });
		} else if (search == '?happiness') {
			this.setState({ activeKey: 'happiness' });
		} else if (search == '?rightnav') {
			this.setState({ activeKey: 'rightnav' });
			GetCustomiNavigationAction.getCustomNavigation(urlName);
		}
	}
	deleteCustomNavResponse = () => {
		let response = DeleteCustomNavigationStore.getResponse();
		if (response.status == 200) {
			GetCustomiNavigationAction.getCustomNavigation(urlName);
			message.success(response.message);
		}
	}
	updatecustomNavResponse = () => {
		let response = UpdateCustomNavigationStore.getResponse();
		if (response.status == 200) {
			GetCustomiNavigationAction.getCustomNavigation(urlName);
			message.success(response.message);
		}
		this.setState({ customNavLoader: false })

	}
	createCustomNavResponse = () => {
		let response = CreateCustomNavigationStore.getResponse();
		if (response.status == 200) {
			GetCustomiNavigationAction.getCustomNavigation(urlName);
			message.success(response.message)
		}
		this.setState({ customNavLoader: false })
	}
	getCustomNavResposen = () => {
		let response = GetCustomNavigationStore.getResponse();
		if (response.status == 200) {
			this.setState({ navigationGroup: response.hits, comparisonData: _.cloneDeep(response.hits), })
		}
		else {
			this.setState({ navigationGroup: [] })
		}
	}
	onAddNavigationGroup = () => {
		let { navigationGroup } = this.state;
		navigationGroup.push(setInitialState());
		this.setState({
			navigationGroup
		});
	}
	onRemoveNavigationGroup = (profileId, tabId) => {
		let domainName = urlName;
		confirm({
			title: RemoveNavigationMessages.title,
			content: RemoveNavigationMessages.content,
			okText: RemoveNavigationMessages.okText,
			cancelText: RemoveNavigationMessages.cancelText,
			onCancel() { },
			onOk() {
				DeleteCustomNavigationAction.delete(domainName, tabId);
			}
		});
	}
	tabFieldName = (key, e) => {
		var NavigationData = this.state.navigationGroup;
		NavigationData[key].tabName = _.truncate(e.target.value,
			{ 'length': 18, 'omission': '' });
		this.setState({
			navigationGroup: NavigationData
		});
	}
	tablinkAddress = (key, e) => {
		var NavigationData = this.state.navigationGroup;
		NavigationData[key].link = e.target.value;
		this.setState({
			navigationGroup: NavigationData
		});
	}
	onUpdateData = (index, tabId) => {
		this.setState({ customNavLoader: true, selectedIndex: index })
		var originalData = this.state.comparisonData[index];
		var editedData = this.state.navigationGroup[index];
		onUpdateSidebarData({ index, tabId, originalData, editedData }, this.disableLoader);
	}
	tooltipMessage = (key, e) => {
		var NavigationData = this.state.navigationGroup;
		NavigationData[key].tooltipComment = e.target.value;
		this.setState({
			navigationGroup: NavigationData
		});
	}
	onPositionChange = (key, e) => {
		var NavigationData = this.state.navigationGroup;
		NavigationData[key].linkPosition = e.target.value;
		this.setState({
			navigationGroup: NavigationData
		});
	}
	onChange = (key, e) => {
		var NavigationData = this.state.navigationGroup;
		NavigationData[key].linkType = e.target.value;
		this.setState({
			navigationGroup: NavigationData
		});
	}
	onSend = (index) => {
		this.setState({ customNavLoader: true, selectedIndex: index })
		var tabData = this.state.navigationGroup[index];
		onSendSidebarData({ tabData, index, }, this.disableLoader);
	}
	disableLoader = () => {
		this.setState({ customNavLoader: false })
	}
	uploadFile = (event, key) => {
		var NavigationData = this.state.navigationGroup;
		NavigationData[key].imageFile = event.target.files[0];
		this.setState({
			navigationGroup: NavigationData
		});
	}
	domainLogoUploadResponse = () => {
		if (UploadProfileLogoStore.getResponse() && UploadProfileLogoStore.getResponse().status == 200) {
			var imageList = this.state.fileList;
			imageList[0].status = 'done';
			this.setState({
				fileList: imageList,
				flag: !this.state.flag
			});
			GetIntegrationAction.getintegration(urlName);
		} else {
			message.error("failed to upload");
			this.setState({
				fileList: []
			});
		}
	}
	onGetIntegrations() {
		let allData = GetIntegrationStore.getResponse().integrations;
		let emailSubjectLineData = this.emailSubjectLineDataManipulation(GetIntegrationStore.getResponse().emailSubjectLine);
		let integrations = Object.keys(integrationImages).map(ele => {
			return {
				label: ele,
				value: allData[ele]
			}
		});
		let domainCssControlConfig = this.domainCssManipulation(GetIntegrationStore.getResponse().domainColors)
		let apiIntegrations = Object.keys(authIntegrationImages).map(ele => {
			return {
				label: ele,
				value: allData[ele]
			}
		});
		let statements = GetIntegrationStore.getResponse().defaultPersonalityTone
		let selectedCSSType = this.selectedColourType(GetIntegrationStore.getResponse().domainColors)
		const analyticsScript = GetIntegrationStore.getResponse().analyticsScript;
		if (analyticsScript && analyticsScript.scriptText) {
			appendAnalyticsScript(analyticsScript);
		}
		this.setState({
			statements,
			locationsData: GetIntegrationStore.getResponse(),
			integrations: integrations,
			analyticsScriptType: GetIntegrationStore.getResponse() && GetIntegrationStore.getResponse().analyticsScript ? GetIntegrationStore.getResponse().analyticsScript.scriptType : 'internal',
			analyticsScriptText: GetIntegrationStore.getResponse() && GetIntegrationStore.getResponse().analyticsScript ? GetIntegrationStore.getResponse().analyticsScript.scriptText : '',
			analyticsScriptActivate: GetIntegrationStore.getResponse() && GetIntegrationStore.getResponse().analyticsScript ? GetIntegrationStore.getResponse().analyticsScript.activate : false,
			analyticsScriptPlacement: GetIntegrationStore.getResponse() && GetIntegrationStore.getResponse().analyticsScript ? GetIntegrationStore.getResponse().analyticsScript.placement : 'head',
			apiIntegrations: apiIntegrations,
			loading: false,
			isSignUpRequire: GetIntegrationStore.getResponse().signUp,
			showBulkLocationEdit: GetIntegrationStore.getResponse().showBulkLocationEdit,
			happinessRating: GetIntegrationStore.getResponse().happinessRating,
			emailSubjectLine: GetIntegrationStore.getResponse().emailSubjectLine,
			subjectLineConfig: emailSubjectLineData,
			starIconColor: GetIntegrationStore.getResponse().starIconColor,
			displayColorPicker: false,
			domainCssControlConfig: domainCssControlConfig,
			domainCssColor: _.cloneDeep(GetIntegrationStore.getResponse().domainColors),
			selectedCSSType: selectedCSSType,
			domainLanguages: GetIntegrationStore.getResponse().domainLanguages,
			defaultLanguage: GetIntegrationStore.getResponse().defaultLanguage,
			whiteLabelImages: GetIntegrationStore.getResponse().whiteLabelImages,
			tabVisibility: GetIntegrationStore.getResponse().tabControl,
			subTabVisibility: GetIntegrationStore.getResponse().settingsSubTabControl,
			reviewsInboxControl: GetIntegrationStore.getResponse().reviewsInboxControl.isResponseEnabled,
			manageLocationControl: GetIntegrationStore.getResponse().manageLocationControl.scope,
			hasAiResponse: GetIntegrationStore.getResponse().hasAiResponse || false,
			hasSentimentAnalysis: GetIntegrationStore.getResponse().hasSentimentAnalysis || false,
			hasLanguageDetection: GetIntegrationStore.getResponse().hasLanguageDetection || false,
			responseTemplate: (GetIntegrationStore.getResponse().profileSettings && GetIntegrationStore.getResponse().profileSettings.responseTemplate) || false,
			signUpPosition: GetIntegrationStore.getResponse().signUpPosition || 'Default',
			marketingMessage: GetIntegrationStore.getResponse().marketingMessage,
			htmlStyle: GetIntegrationStore.getResponse().style,
			isBusinessEmail: GetIntegrationStore.getResponse().emailValidation || false,
			pageTitle: GetIntegrationStore.getResponse().pageTitle || '',
			pageDescription: GetIntegrationStore.getResponse().pageDescription || '',
			supportEmail: GetIntegrationStore.getResponse().supportEmail || '',
			newUserNotificationEmails: GetIntegrationStore.getResponse().newUserNotificationEmails || '',
			newProfileNotificationEmails: GetIntegrationStore.getResponse().newProfileNotificationEmails || '',
			addressLine: GetIntegrationStore.getResponse().address ? GetIntegrationStore.getResponse().address.addressLine ? GetIntegrationStore.getResponse().address.addressLine : '' : '',
			city: GetIntegrationStore.getResponse().address ? GetIntegrationStore.getResponse().address.city ? GetIntegrationStore.getResponse().address.city : '' : '',
			stateName: GetIntegrationStore.getResponse().address ? GetIntegrationStore.getResponse().address.state ? GetIntegrationStore.getResponse().address.state : '' : '',
			country: GetIntegrationStore.getResponse().address ? GetIntegrationStore.getResponse().address.country ? GetIntegrationStore.getResponse().address.country : '' : '',
			zipCode: GetIntegrationStore.getResponse().address ? GetIntegrationStore.getResponse().address.zipCode ? GetIntegrationStore.getResponse().address.zipCode : '' : '',
			fromAddress: GetIntegrationStore.getResponse().whiteLabelDetails && GetIntegrationStore.getResponse().whiteLabelDetails.fromAddress && GetIntegrationStore.getResponse().whiteLabelDetails.fromAddress || '',
			fromName: GetIntegrationStore.getResponse().whiteLabelDetails && GetIntegrationStore.getResponse().whiteLabelDetails.fromName && GetIntegrationStore.getResponse().whiteLabelDetails.fromName || '',
			fromReviewAddress: GetIntegrationStore.getResponse().whiteLabelDetails && GetIntegrationStore.getResponse().whiteLabelDetails.fromReviewAddress && GetIntegrationStore.getResponse().whiteLabelDetails.fromReviewAddress || '',

		})
		applyWhiteLabelHeadTags(GetIntegrationStore.getResponse().whiteLabelImages);
		if (this.state.htmlStyle == "") {
			this.setState({
				htmlStyle: `<div style="position: absolute; top: 0; left: 0; padding: 30px; width: 100%; height: 100%; z-index: 3; background-image: url(https://images.unsplash.com/photo-1511914678378-2906b1f69dcf?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1280&h=1280&fit=crop)"">             
			<div style="display: flex; flex-direction: row; align-items: center; justify-content: flex-start; flex-wrap: nowrap;  text-align: center; max-width: 240px;"> 
			<img src="https://lc-whitelabel-images-prod-dev.s3-us-west-2.amazonaws.com/images/localhost%3A3000/domainLogo?time=1607965061825" /> 											 
		   </div> 
		   </div>`
			})
		}
		if (this.state.marketingMessage == "") {
			this.setState({
				marketingMessage: `<h2 style="color : red; font-size : x-large;">Marketing Message</h2>`
			})
		}
	}
	selectedColourType = (color) => {
		let selectedType;
		_.map(cssCustomOptions, function (item, key) {
			if (_.isEqual(color, savedCSSValues[item.value])) {
				selectedType = item;
			}
		})
		if (selectedType) {
			return selectedType
		} else {
			return { label: "Customize", value: "Custom" }
		}
	}
	emailSubjectLineDataManipulation(data) {
		let customisedSubjectLine = _.map(this.state.subjectLineConfig, subjectLine => {
			_.map(subjectLine.children, child => {
				child.value = data[child['field']];
				child.isEditing = false;
			})
			return subjectLine
		})
		return customisedSubjectLine
	}
	domainCssManipulation = (currentData) => {
		let customisedCssData = _.map(this.state.domainCssControlConfig, domaincss => {
			_.map(domaincss.children, child => {
				child.value = currentData[child['field']];
				child.isEditing = false;
			})
			return domaincss
		})
		return customisedCssData;
	}
	onEditIntegrations = () => {
		this.setState({ metaLoader: false, scriptLoader: false })
		if (EditIntegrationStore.getResponse().status == 200) {
			message.success(EditIntegrationStore.getResponse().message)
			GetIntegrationAction.getintegration(urlName);

		} else if (EditIntegrationStore.getResponse().data && EditIntegrationStore.getResponse().data.message) {
			message.error(EditIntegrationStore.getResponse().data.message)
		} else {
			message.error("something went wrong")
		}


	}
	changeControl(key, e) {
		let data = this.state.integrations;
		data[key].value = e.target.checked;
		this.setState({
			integrations: data
		})
	}
	changeIntegrationVisibility(key, e) {
		let data = this.state.apiIntegrations;
		data[key].value = e.target.checked;
		this.setState({
			apiIntegrations: data
		})
	}
	listIntegrations() {
		var self = this;
		return _.map(this.state.integrations, function (item, key) {
			return <li key={key} className={item.value ? "active" : "inactive"}>
				<span><img src={getSourceLogo(item.label)} /></span>
				<input onChange={self.changeControl.bind(self, key)} checked={item.value} type="checkbox" />
			</li>
		})
	}
	listApiIntegrations = () => {
		var self = this;
		return _.map(this.state.apiIntegrations, function (item, key) {
			return <Tooltip title={item.label == 'bing' && 'Coming Soon'}><li key={key} className={item.value ? "active" : "inactive"}>
				<span><img src={getSourceLogo(item.label)} /></span>
				<input onChange={item.label != 'bing' && self.changeIntegrationVisibility.bind(self, key)} checked={item.value} type="checkbox" />
			</li></Tooltip>
		})
	}
	updateControl() {
		let formatData = {}
		_.map(this.state.integrations, function (item, key) {
			formatData[item.label] = item.value;
		})
		_.map(this.state.apiIntegrations, function (item, key) {
			formatData[item.label] = item.value;
		})
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			integrations: formatData
		}
		EditIntegrationAction.editintegration(data)
	}
	onLanguageVisibilityChange = (key, value) => {
		let domainLanguages = this.state.domainLanguages;
		if (domainLanguages.includes(key)) {
			domainLanguages = domainLanguages.filter(v => v !== key);
		} else {
			domainLanguages.push(key)
		}
		this.setState({
			domainLanguages
		})
	}
	changeSignupStatus(status) {
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			signUp: status,
			signUpPosition: this.state.signUpPosition
		}
		EditIntegrationAction.editintegration(data)
		this.setState({
			isSignUpRequire: status
		})
	}
	changeEmailBlockStatus = (status) => {
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			emailValidation: status,
		}
		EditIntegrationAction.editintegration(data)
		this.setState({
			isBusinessEmail: status
		})
	}
	changeSignupPageView = (e) => {
		this.setState({
			signUpPosition: e.target.value
		})

	}

	onHandleMarketingMessage = (e) => {

		this.setState({
			marketingMessage: e.target.value
		})


	}
	onHandleHtmlStyle = (e) => {
		this.setState({
			htmlStyle: e.target.value
		})

	}
	onPageTitleChange = (e) => {
		this.setState({
			pageTitle: e.target.value
		})

	}
	onPageDescriptionChange = (e) => {
		this.setState({
			pageDescription: e.target.value
		})
	}
	onSupportEmailChange = (e) => {
		this.setState({
			supportEmail: e.target.value
		})
	}
	onUserNotificationEmailChange = (e) => {
		this.setState({
			newUserNotificationEmails: e.target.value
		})
	}
	onProfileNotificationEmailChange = (e) => {
		this.setState({
			newProfileNotificationEmails: e.target.value
		})
	}
	onAddressLineChange = (e) => {
		this.setState({
			addressLine: e.target.value
		})
	}
	onCityChange = (e) => {
		this.setState({
			city: e.target.value
		})
	}
	onStateNameChange = (e) => {
		this.setState({
			stateName: e.target.value
		})
	}
	onCountryChange = (e) => {
		this.setState({
			country: e.target.value
		})
	}
	onZipCodeChange = (e) => {
		this.setState({
			zipCode: e.target.value
		})
	}

	saveScriptData = async () => {

		// const scriptTagRegex = /<script\b[^>]*>([\s\S]*?)<\/script>/i;
		// let checkregex = scriptTagRegex.test(this.state.analyticsScriptText);	
		// let checkValid = true;
		// if(this.state.analyticsScriptType == 'internal'){
		// 	const regex = /<script\b[^>]*>([\s\S]*?)<\/script>/gi;
		// 	let match;
		// 	while ((match = regex.exec(this.state.analyticsScriptText)) !== null) {
		// 		// Check if the script tag contains an src attribute
		// 		const srcMatch = match[0].match(/src="[^"]+"/);

		// 		// Check the content inside the script tag
		// 		const innerContent = match[1].trim(); // match[1] contains the content between <script> and </script>

		// 		if (srcMatch) {
		// 			// console.log(`Found <script> tag with src: ${srcMatch[0]}`);
		// 		} else {
		// 			// checkValid = false
		// 			message.error('Found <script> tag without src.')

		// 		}

		// 		if (innerContent) {
		// 			// console.log('Contains inline script:', innerContent);
		// 		} else {
		// 			checkValid = false

		// 			message.error('No inline script present.');
		// 		}
		// 	}
		// }
		// if (checkregex && checkValid) {
		if (this.state.analyticsScriptText.includes('<script>') || this.state.analyticsScriptText.includes('</script>')) {
			message.error('Please remove <script> and </script> tags')
		}
		else {
			this.setState({ scriptLoader: true })
			let data = {
				domain: urlName,
				userId: cookie.readCookie("userId"),
				analyticsScript: {
					activate: this.state.analyticsScriptActivate,
					placement: this.state.analyticsScriptPlacement,
					scriptText: this.state.analyticsScriptText,
					scriptType: this.state.analyticsScriptType
				}
			}
			EditIntegrationAction.editintegration(data)
		}
		// else if(checkValid && !checkregex){
		// 	message.error('No valid <script> tag found. Ensure the script tag is properly formatted.')
		// }

	}
	saveMetaData = () => {
		this.setState({ metaLoader: true })
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			pageTitle: this.state.pageTitle,
			pageDescription: this.state.pageDescription,
			supportEmail: this.state.supportEmail,
			address: { 'addressLine': this.state.addressLine, 'city': this.state.city, 'state': this.state.stateName, 'zipCode': this.state.zipCode, 'country': this.state.country },
			signUp: this.state.isSignUpRequire,
			newUserNotificationEmails: this.state.newUserNotificationEmails,
			newProfileNotificationEmails: this.state.newProfileNotificationEmails,
			whiteLabelDetails: {
				fromAddress: this.state.fromAddress,
				fromReviewAddress: this.state.fromReviewAddress,
				fromName: this.state.fromName
			}

		}
		EditIntegrationAction.editintegration(data)
	}
	saveSignUpPageControl = () => {
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			signUpPosition: this.state.signUpPosition,
			marketingMessage: this.state.marketingMessage,
			style: this.state.htmlStyle,
			signUp: this.state.isSignUpRequire
		}
		EditIntegrationAction.editintegration(data)
	}
	changeInboxResponseControl = (status) => {
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			reviewsInboxControl: { isResponseEnabled: status },
			signUp: this.state.isSignUpRequire
		}
		EditIntegrationAction.editintegration(data)
		this.setState({
			reviewsInboxControl: status
		})
	}
	changeAIResponse = (airesponse) => {
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			hasAiResponse: airesponse,
			signUp: this.state.isSignUpRequire
		}
		EditIntegrationAction.editintegration(data)
		this.setState({
			hasAiResponse: airesponse
		})
	}
	changeSentimentAnalysis = (sentiment) => {
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			hasSentimentAnalysis: sentiment,
			signUp: this.state.isSignUpRequire
		}
		EditIntegrationAction.editintegration(data)
		this.setState({
			hasSentimentAnalysis: sentiment
		})
	}
	changeResponseTemplate = (value) => {
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			profileSettings: { responseTemplate: value },
			signUp: this.state.isSignUpRequire
		}
		EditIntegrationAction.editintegration(data)
		this.setState({ responseTemplate: value })
	}
	changeLanguageDetection = (language) => {
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			hasLanguageDetection: language,
			signUp: this.state.isSignUpRequire
		}
		EditIntegrationAction.editintegration(data)
		this.setState({
			hasLanguageDetection: language
		})
	}
	changeLocationEditStatus = (status) => {
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			manageLocationControl: { scope: this.statusExtractorForEnumValue(status) },
			signUp: this.state.isSignUpRequire
		}
		EditIntegrationAction.editintegration(data)
		this.setState({
			manageLocationControl: status
		})
	}
	changeBulkTabVisibilityStatus = (status) => {
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			showBulkLocationEdit: status
		}
		EditIntegrationAction.editintegration(data)
		this.setState({
			showBulkLocationEdit: status
		})
	}
	onTabVisibilityChange = (key, value) => {
		let tabVisibility = this.state.tabVisibility;
		tabVisibility[key] = value;
		this.setState({
			tabVisibility
		})
	}
	onSubTabVisibilityChange = (key, value) => {
		let subTabVisibility = this.state.subTabVisibility;
		subTabVisibility[key] = value;
		this.setState({
			subTabVisibility
		})
	}
	saveSubjectLineData = (field, value) => {
		let emailSubjectLine = this.state.emailSubjectLine
		emailSubjectLine[field] = value

		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			emailSubjectLine: emailSubjectLine
		}
		EditIntegrationAction.editintegration(data)
	}
	subjectEditCancel = (index, key) => {
		let subjectLineConfig = this.state.subjectLineConfig;
		subjectLineConfig[index].children[key].isEditing = false;
		subjectLineConfig[index].children[key].value = this.state.emailSubjectLine[subjectLineConfig[index].children[key].field]
		this.setState({ subjectLineConfig })
	}
	onCloseDomainColorPicker = (index, key) => {
		let domainCssControlConfig = this.state.domainCssControlConfig;
		domainCssControlConfig[index].children[key].isEditing = false;
		domainCssControlConfig[index].children[key].value = this.state.domainCssColor[domainCssControlConfig[index].children[key].field]
		this.setState({ domainCssControlConfig })
	}
	onApplyDomainColor = (field, value, index, key) => {
		let domainCssControlConfig = this.state.domainCssControlConfig;
		domainCssControlConfig[index].children[key].isEditing = false;
		domainCssControlConfig[index].children[key][field] = value;
		let domainCssColor = this.state.domainCssColor;
		domainCssColor[field] = value;
		let selectedCSSType = this.selectedColourType(domainCssColor)
		this.setState({ domainCssControlConfig, domainCssColor, selectedCSSType })
	}
	clearPreviewColor = () => {
		let domainCssControlConfig = this.domainCssManipulation(GetIntegrationStore.getResponse().domainColors)
		let selectedCSSType = this.selectedColourType(GetIntegrationStore.getResponse().domainColors)
		this.setState({
			domainCssColor: GetIntegrationStore.getResponse().domainColors,
			domainCssControlConfig,
			selectedCSSType
		})
	}
	saveLanguageControlConfig = () => {
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			domainLanguages: this.state.domainLanguages,
			signUp: this.state.isSignUpRequire
		}
		EditIntegrationAction.editintegration(data)
	}
	changeRatingValue = (item, key) => {
		let rating = this.state.happinessRating
		rating[item] = key.key
		this.setState({
			happinessRating: rating
		})
	}
	saveRatingStatement = () => {
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			defaultPersonalityTone: this.state.statements,
			signUp: this.state.isSignUpRequire
		}
		EditIntegrationAction.editintegration(data)
	}
	saveRatingConfig = () => {
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			happinessRating: this.state.happinessRating,
			signUp: this.state.isSignUpRequire
		}
		EditIntegrationAction.editintegration(data)
	}
	savetabControlConfig = () => {
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			tabControl: this.state.tabVisibility,
			signUp: this.state.isSignUpRequire
		}
		EditIntegrationAction.editintegration(data)
	}
	saveSubtabControlConfig = () => {
		let data = {
			userId: cookie.readCookie("userId"),
			domain: urlName,
			settingsSubTabControl: this.state.subTabVisibility,
			signUp: this.state.isSignUpRequire
		}
		EditIntegrationAction.editintegration(data)
	}
	saveDomainColor = () => {
		let domainCssColor = this.state.domainCssControlConfig
		let cssColor = {};
		_.map(domainCssColor, function (item, index) {
			_.map(item.children, function (data, key) {
				cssColor[data.field] = data.value;
			})
		})
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			domainColors: cssColor,
			signUp: this.state.isSignUpRequire
		}
		EditIntegrationAction.editintegration(data)
		if (cssColor) {
			localStorage.setItem('sidebarBackground', cssColor.sidebarBackground);
			localStorage.setItem('sidebarBorder', cssColor.sidebarBorder);
			localStorage.setItem('sidebarTransparency', cssColor.sidebarTransparency);
			localStorage.setItem('activeTabList', cssColor.activeTabList);
			localStorage.setItem('tabIcon', cssColor.tabIcon);
			localStorage.setItem('activeIcon', cssColor.activeIcon);
			localStorage.setItem('logoBackground', cssColor.logoBackground);
			localStorage.setItem('headerBackground', cssColor.headerBackground);
			localStorage.setItem('headerIcon', cssColor.headerIcon);
		}
	}
	saveStarColor = () => {
		let data = {
			domain: urlName,
			userId: cookie.readCookie("userId"),
			starIconColor: this.state.starIconColor
		}
		EditIntegrationAction.editintegration(data)
	}
	editEmailSubjectLine = (e, f) => {
		let subjectLineData = _.cloneDeep(this.state.emailSubjectLine);
		subjectLineData[e.target.name] = e.target.value
		this.setState({
			emailSubjectLine: subjectLineData
		})
	}

	handleEditClick = (index, key) => {
		let subjectLineConfig = this.state.subjectLineConfig;
		subjectLineConfig[index].children[key].isEditing = true;
		this.setState({ subjectLineConfig })
	}
	onShowDomainColorPicker = (index, key) => {
		let domainCssControlConfig = this.state.domainCssControlConfig;
		domainCssControlConfig[index].children[key].isEditing = true;
		this.setState({ domainCssControlConfig })
	}
	handleSubjectLineChange(index, key, event) {
		let subjectLineConfig = this.state.subjectLineConfig;
		subjectLineConfig[index].children[key].value = event.target.value;
		this.setState({ subjectLineConfig })
	}
	regularExpressinForColorTag(final) {
		if (final && final
			.match(/({{[a-zA-Z]*}})/g) &&
			final
				.match(/({{[a-zA-Z]*}})/g)
				.length) {
			final
				.match(/({{[a-zA-Z]*}})/g)
				.filter((value, index, self) => self.indexOf(value) === index)
				.map(item => final = final.replace(new RegExp(item, "g"), "<span class=variable-tag>" + item + "</span>"));
		}
		return final
	}
	onHandleShowColorPicker = () => {
		this.setState({
			displayColorPicker: true
		})
	}
	onHandleCloseColorPicker = () => {
		this.setState({
			displayColorPicker: false
		})
	}
	handleChangeComplete = (color) => {
		this.setState({ starIconColor: color.hex });
	}
	handleChangeDomainColor = (index, key, color) => {
		let domainCssControlConfig = this.state.domainCssControlConfig;
		domainCssControlConfig[index].children[key].value = color.hex;
		this.setState({ domainCssControlConfig })
	}
	onShowPreview = () => {
		this.setState({
			showCSSPreview: true
		})
	}
	onHidePreview = () => {
		this.setState({
			showCSSPreview: false
		})
	}
	onChangeCSSOption = (event) => {
		this.setState({
			selectedCSSType: event
		})
		if (event.value != 'Custom') {
			let domainCssControlConfig = this.domainCssManipulation(savedCSSValues[event.value])
			this.setState({
				domainCssColor: savedCSSValues[event.value],
				domainCssControlConfig
			})
		} else {
			message.info("Customize your colour");
		}
	}
	handleChange = (fileList) => {
		this.setState({
			fileList: fileList.fileList
		})
	}
	handlePreview = (file) => {
		this.setState({
			previewImage: file.url || file.thumbUrl,
			previewVisible: true,
		});
	}
	handlePreviewCancel = () => {
		this.setState({
			previewVisible: false
		})
	}
	imageFile = (e, a) => {
		var fd = new FormData();
		fd.append('image', e.file);
		fd.append('imageType', this.state.selectedUploadType.value);
		fd.append('domainName', urlName);
		UploadProfileLogoAction.upload(fd)
	}
	removeImage = () => {
		this.setState({
			fileList: [],
		});
	};
	changeUploadType = (e) => {
		this.setState({
			selectedUploadType: e,
			fileList: []
		})
	}
	statusExtractorForEnumValue = (status) => {
		if (status == 'EDIT') {
			return true;
		} else if (status == 'READ_ONLY') {
			return false;
		} else if (status) {
			return 'EDIT';
		} else {
			return 'READ_ONLY';
		}
	}
	setStatement = (value, index) => {
		let upd_statement = this.state.statements.map((obj) => {
			if (obj.rating === index) {
				return { ...obj, statement: value };
			}
			return obj;
		});

		this.setState({ statements: upd_statement })
	}
	onWhiteLabelDetailsChange = (data, type) => {
		this.setState({ [type]: data })
	}
	scriptOnChangeValues = (field, value) => {
		this.setState({ [field]: value })
	}
	domainDetails = () => {
		return (<CustomScrollbar className='authorize-admin-page-scroller'>
			<div className="page-wrapper">
				<div className="border-class">
					<div className='doamin-details-wrapper' style={{ flexWrap: 'wrap' }}>
						<div className='domain-details-items'>
							<MetaData
								pageTitle={this.state.pageTitle}
								pageDescription={this.state.pageDescription}
								supportEmail={this.state.supportEmail}
								profileNotificationEmail={this.state.newProfileNotificationEmails}
								userNotificationEmail={this.state.newUserNotificationEmails}
								addressLine={this.state.addressLine}
								city={this.state.city}
								country={this.state.country}
								stateName={this.state.stateName}
								zipCode={this.state.zipCode}
								onPageTitleChange={this.onPageTitleChange.bind(this)}
								onPageDescriptionChange={this.onPageDescriptionChange.bind(this)}
								onSupportEmailChange={this.onSupportEmailChange.bind(this)}
								onProfileNotificationEmailChange={this.onProfileNotificationEmailChange.bind(this)}
								onUserNotificationEmailChange={this.onUserNotificationEmailChange.bind(this)}
								onAddressLineChange={this.onAddressLineChange.bind(this)}
								onCityChange={this.onCityChange.bind(this)}
								onStateNameChange={this.onStateNameChange.bind(this)}
								onCountryChange={this.onCountryChange.bind(this)}
								onZipCodeChange={this.onZipCodeChange.bind(this)}
								fromAddress={this.state.fromAddress}
								fromReviewAddress={this.state.fromReviewAddress}
								fromName={this.state.fromName}
								onWhiteLabelDetailsChange={this.onWhiteLabelDetailsChange}
							/>
							<div className="admin-review__btn">
								<Button onClick={this.saveMetaData} loading={this.state.metaLoader} className='primary-btn btn-padding-lg'>{languageFile[localStorage.getItem('language')]["23471"]}</Button>
							</div>
						</div>
						<div className='domainlevel-upload'>
							<div className='replace-logo' style={{ minWidth: '300px' }}>
								<h3>New Profile Settings</h3>
								<div className="signup-option" style={{ justifyContent: 'space-between' }}>
									<span style={{ color: 'var(--med-drk-text)' }}>Response template</span>
									<Switch checked={this.state.responseTemplate} onChange={this.changeResponseTemplate.bind(this)} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</CustomScrollbar>

		)
	}

	integrationSection = () => {
		return <CustomScrollbar className='authorize-admin-page-scroller' >
			<div className="page-wrapper" >
				<div className="integration">
					<div className="integration__brand">
						<div className="integration__brand--subhead">
							{/* <span><img src={`/images/${urlName}/logo-icon.png`} /></span> */}
							{/* <h3>{this.state.locationsData && this.state.locationsData.domain}</h3> */}
							<h5>Select the integrations (click on/off) to presents as available for each Profile. Click "Update" to save changes.</h5>
						</div>
						{/* <div className="integration__brand--btn">
					<Button key="submit" type="primary" onClick={this.updateControl}>{languageFile[localStorage.getItem('language')]["23471"]}</Button>
				</div> */}
					</div>
					<h3>{languageFile[localStorage.getItem('language')]["24361"]}</h3>
					<ul className="integration__list list_padding">
						{this.listApiIntegrations()}
					</ul>
					<h3>{languageFile[localStorage.getItem('language')]["24511"]}</h3>
					<ul className="integration__list">
						{this.listIntegrations()}
					</ul>
					<div className="integration--btn">
						<Button key="submit" className='primary-btn btn-padding-lg' onClick={this.updateControl}>{languageFile[localStorage.getItem('language')]["23471"]}</Button>
					</div>
				</div>
			</div>
		</CustomScrollbar>
	}

	languageSection = () => {
		let self = this;
		return <div className="page-wrapper" ><div className="border-class">
			<div className="border-class--subhead">
				<h5>Toggle the languages available to Profile users. Click "Update" to save changes.</h5>
			</div>
			<div className="border-class__header">

				<h4 className="hapiness-header">Language Control</h4>
			</div>
			<div className="admin-visible">
				{_.map(availableLanguages, function (item, key) {
					return <div className="admin-visible__item" key={key}>
						<h5>{item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()}</h5>
						<Switch checked={self.state.domainLanguages.includes(key)} disabled={key == self.state.defaultLanguage} onChange={self.onLanguageVisibilityChange.bind(self, key)} />
					</div>
				})
				}
			</div>
			<div className="border-class--btn">
				<Button onClick={this.saveLanguageControlConfig} className='primary-btn btn-padding-lg'>{languageFile[localStorage.getItem('language')]["23471"]}</Button>
			</div>
		</div></div>
	}

	moduleVisibilitySection = () => {
		let self = this;
		return (<CustomScrollbar className='authorize-admin-page-scroller' >
			<div className="page-wrapper" >
				<div className="border-class">
					<div className="border-class--subhead">
						<h5>Toggle the module visibility defaults for each Profile. Click "Update" to save changes.</h5>
					</div>
					<div className="border-class__header">
						<h3 className="hapiness-header">Tab Visibility Setting</h3>
					</div>
					<div className="admin-visible">
						{_.map(mappingTabName, function (item, key) {
							return <div className="admin-visible__item" key={key}>
								<h5>{item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()}</h5>
								<Switch checked={self.state.tabVisibility[key]} onChange={self.onTabVisibilityChange.bind(self, key)} />
							</div>
						})
						}
					</div>
					<div className="border-class--btn">
						<Button onClick={this.savetabControlConfig} className='primary-btn btn-padding-lg'>{languageFile[localStorage.getItem('language')]["23471"]}</Button>
					</div>
					{this.state.tabVisibility.REVIEWS &&
						<div className="signup-option">
							<span>ReviewsInbox Response
								<Tooltip title="Control the visibily of Reply,Explore,Note,Email options in the ReviewsInbox.">
									<i className="fa fa-info-circle" aria-hidden="true" style={{ marginLeft: 3 }}></i>
								</Tooltip>
							</span>
							<Switch checked={this.state.reviewsInboxControl} onChange={this.changeInboxResponseControl.bind(this)} />
						</div>}
					{this.state.tabVisibility.MANAGE_LOCATIONS &&
						<div className="signup-option">
							<span>Manage Locations Edit Option
								<Tooltip title="Control the update option in single location edit.">
									<i className="fa fa-info-circle" aria-hidden="true" style={{ marginLeft: 3 }}></i>
								</Tooltip>
							</span>
							<Switch checked={this.statusExtractorForEnumValue(this.state.manageLocationControl)} onChange={this.changeLocationEditStatus.bind(this)} />
						</div>}
					{/* </div> */}
					<div className="border-class__header">
						<h3 className="hapiness-header">{languageFile[localStorage.getItem('language')]["25551"]}</h3>
					</div>
					<div className="admin-visible">
						{_.map(settingLabelMap, function (item, key) {
							return <div className="admin-visible__item" key={key}>
								<h5>{item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()}</h5>
								<Switch checked={self.state.subTabVisibility[key]} onChange={self.onSubTabVisibilityChange.bind(self, key)} />
							</div>
						})
						}
					</div>
					<div className="border-class--btn">
						<Button onClick={this.saveSubtabControlConfig} className='primary-btn btn-padding-lg'>{languageFile[localStorage.getItem('language')]["23471"]}</Button>
					</div>
				</div></div></CustomScrollbar>)
	}
	aiSettingsTab = () => {
		return <CustomScrollbar className='authorize-admin-page-scroller' >
			<div className="page-wrapper" >
				<div className="border-class" >
					<div className="border-class--subhead">
						<h5>Select the AI functionality available for the domain profiles. Click "Update" to save changes.</h5>
					</div><div className="signup-option" style={{ marginTop: '2rem' }}>
						<span>Identify & Mark Review Language
							<Tooltip title="Tag each incoming review with a primary language of the comments">
								<i className="fa fa-info-circle" aria-hidden="true" style={{ marginLeft: 3 }}></i>
							</Tooltip>
						</span>
						<Switch checked={this.state.hasLanguageDetection} onChange={this.changeLanguageDetection.bind(this)} />
					</div>
					<div className="signup-option" >
						<span>AI-Powered Responses
							<Tooltip title="AI powered responses for reviews ">
								<i className="fa fa-info-circle" aria-hidden="true" style={{ marginLeft: 3 }}></i>
							</Tooltip>
						</span>
						<Switch checked={this.state.hasAiResponse} onChange={this.changeAIResponse.bind(this)} />
					</div>
					<div className="signup-option">
						<span>Sentiment Analysis & Emotion Detection
							<Tooltip title="Identify the primary review comment topics and the associated sentiment & emotions">
								<i className="fa fa-info-circle" aria-hidden="true" style={{ marginLeft: 3 }}></i>
							</Tooltip>
						</span>
						<Switch checked={this.state.hasSentimentAnalysis} onChange={this.changeSentimentAnalysis.bind(this)} />
					</div>
					<div className='block-contents'>
						<h3 className="hapiness-header">Default AI Tone Statements</h3>
						<div className="admin-review">
							<div className='default-tone-block'>

								<div>
									<h4>5 Star</h4><TextArea
										// className={style.textArea}
										rows={3}
										placeholder="5-Star statement here."
										maxLength={250}
										onChange={(e) => this.setStatement(e.target.value, 5)}
										value={this.state.statements[4].statement}
									/>
								</div>
								<div><h4>4 Star</h4><TextArea
									// className={style.textArea}
									rows={3}
									placeholder="4-Star statement here."
									maxLength={250}
									onChange={(e) => this.setStatement(e.target.value, 4)}
									value={this.state.statements[3].statement}
								/>
								</div>
								<div><h4>3 Star</h4>
									<TextArea
										// className={style.textArea}
										rows={3}
										placeholder="3-Star statement here."
										maxLength={250}
										onChange={(e) => this.setStatement(e.target.value, 3)}
										value={this.state.statements[2].statement}
									/>
								</div>
								<div><h4>2 Star</h4>
									<TextArea
										// className={style.textArea}
										rows={3}
										placeholder="2-Star statement here."
										maxLength={250}
										onChange={(e) => this.setStatement(e.target.value, 2)}
										value={this.state.statements[1].statement}
									/>

								</div>
								<div>
									<h4>1 Star</h4><TextArea
										// className={style.textArea}
										rows={4}
										placeholder="1-Star statement here."
										maxLength={250}
										onChange={(e) => this.setStatement(e.target.value, 1)}
										value={this.state.statements[0].statement}
									/>
								</div>
							</div>
							<div className="admin-review__btn">
								<Button onClick={this.saveRatingStatement} className='primary-btn btn-padding-lg'>{languageFile[localStorage.getItem('language')]["23471"]}</Button>
							</div>

						</div>
					</div></div></div>
		</CustomScrollbar>
	}
	customLinks = () => {
		return <CustomScrollbar className='authorize-admin-page-scroller'>
			<div className='settings__content'>
				<CustomNavigationbarWrapper
					navigationGroup={this.state.navigationGroup}
					onAddNavigationGroup={this.onAddNavigationGroup}
					tooltipMessage={this.tooltipMessage}
					tabFieldName={this.tabFieldName}
					onRemoveNavigationGroup={this.onRemoveNavigationGroup}
					onUpdateData={this.onUpdateData}
					onSend={this.onSend}
					uploadFile={this.uploadFile}
					onChange={this.onChange}
					onPositionChange={this.onPositionChange}
					tablinkAddress={this.tablinkAddress}
					loader={this.state.customNavLoader}
					selectedIndex={this.state.selectedIndex} />
			</div>
		</CustomScrollbar>
	}
	happinessSection = () => {
		let self = this;
		const menu = (props) => (
			<Menu onClick={this.changeRatingValue.bind({}, props)}>
				<Menu.Item key="1">Promoter/Happy</Menu.Item>
				<Menu.Item key="0">Neutral</Menu.Item>
				<Menu.Item key="-1">Detractor/Unhappy</Menu.Item>

			</Menu>
		);
		return <CustomScrollbar className='authorize-admin-page-scroller' >
			<div className="page-wrapper" >
				<div className="border-class" style={{ height: '100vh' }}>
					<div className="border-class--subhead">
						<h5>Set the calculation for Happiness Score (calculated as Happy % - Unhappy %). Click "Update" to save changes.</h5>
					</div>
					<h3 className="hapiness-header">Happiness/NPS Setting</h3>
					<div className="admin-review">
						{_.map(ratingList, function (item, key) {
							return <div className="admin-review__item" key={key}>
								<h4>{labelMap[item]}</h4>
								<Dropdown overlay={menu(item)} key={key}>
									<Button>
										{happiessRateMap[self.state.happinessRating[item]]} <Icon type="down" />
									</Button>
								</Dropdown>
							</div>
						})
						}
						<div className="admin-review__btn">
							<Button onClick={this.saveRatingConfig} className='primary-btn btn-padding-lg'>{languageFile[localStorage.getItem('language')]["23471"]}</Button>
						</div>
					</div>
				</div>
			</div>
		</CustomScrollbar>
	}
	tabChange = (key) => {
		this.setState({ activeKey: key })
		this.props.history.push(`/authorize/admin/domain-control?${key}`)
		if (key == 'rightnav') {
			GetCustomiNavigationAction.getCustomNavigation(urlName);
		}
	}
	render() {
		let self = this;
		const menu = (props) => (
			<Menu onClick={this.changeRatingValue.bind({}, props)}>
				<Menu.Item key="1">Promoter/Happy</Menu.Item>
				<Menu.Item key="0">Neutral</Menu.Item>
				<Menu.Item key="-1">Detractor/Unhappy</Menu.Item>

			</Menu>
		);
		if (this.state.loading) {
			return <div className="loader-main">
				<div className="loader"></div>
			</div>
		}
		return (
			<LocaleProvider locale={enUS}>
				<Aux>
					<Header changeToProfilesPage={this.props.changeToProfilesPage}
						header='Domain Control'
						enableRightNavigation={this.props.enableRightNavigation}
						addElement={false}
						addInput={false}
					/>
					<div className='ant-tabs-section'>
						<Tabs activeKey={this.state.activeKey} onTabClick={this.tabChange}>
							<TabPane tab={'Domain Settings'} key="settings">
								{this.domainDetails()}
							</TabPane>
							<TabPane tab={'Integrations'} key="integrations">
								{this.integrationSection()}
							</TabPane>
							<TabPane tab={'Languages'} key="languages">
								{this.languageSection()}
							</TabPane>
							<TabPane tab={'Module Visibility'} key="visibility">
								{this.moduleVisibilitySection()}
							</TabPane>
							<TabPane tab={'AI Settings'} key="ai">
								{this.aiSettingsTab()}
							</TabPane>
							<TabPane tab={'Happiness'} key="happiness">
								{this.happinessSection()}
							</TabPane>
							<TabPane tab={'Navigation'} key="rightnav">
								{this.customLinks()}
							</TabPane>
						</Tabs>
					</div>

					<Modal
						visible={this.state.showCSSPreview}
						width={800}
						onCancel={this.onHidePreview}
						footer={null}>
						<div style={{ width: "800px" }}>
							<PreviewComponent
								domainColors={this.state.domainCssColor} />
						</div>
					</Modal>
				</Aux>
			</LocaleProvider >
		)
	}
}

export default IntegrationControl;